import React, { useEffect, useState } from "react";
import s from "./RolePermission.module.scss";
import SelectField from "../../../../../../global components/Forms/SelectField/SelectField";
import {
  Roles,
  teamPermission,
} from "../../../../../../libs/Utils/Types/Teams";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import useSWR from "swr";
import {
  parseClientError,
  swrFetcher,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../libs/api/Endpoints";
import { Empty, } from "antd";
import useSWRMutation from "swr/mutation";
import { SuccessDataType } from "../../../../../../libs/api/types";
import Unauthorised from "../../../../../../global components/Unauthorised";
import { ThreeDots } from "react-loader-spinner";
import { generateResult } from "../../../../../../global components/ResultModal/ResultModal";
function RolePermission() {
  const token = UseAuthToken();

  const [filter, setFilter] = useState<string>("");
  const [/*newsUpdates*/, setNewsUpdates] = useState<string[]>([]);
  const [rolePermission, setPermissions] = useState<Roles>();
  const [roleUnauthorized, setRoleUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  function handleFilter(value: string) {
    setFilter(value);
  }
  const {
    data: roles,
    isLoading,
    error,
    mutate,
  } = useSWR<{data:Roles[]}, any, any>(
    token ? ["api/admin/team/roles", token] : null,
    swrFetcher,
    {
      revalidateOnFocus: true,
      shouldRetryOnError: false, // Disable retrying on errors
    }
  );
  const {
    data: permi,
    mutate:mutatePermission,
  } = useSWR<{data:teamPermission}, any, any>(
    token ? ["api/admin/team/permissions", token] : null,
    swrFetcher,
    {
      revalidateOnFocus: true,
      shouldRetryOnError: false, // Disable retrying on errors
    }
  );

  const { trigger: updateRolePermission, isMutating } = useSWRMutation(
    `api/admin/team/roles/${filter ? filter : roles && roles.data[0].id}`,
    swrMutationFetcher
  );
  const handleNewsUpdatesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;

    setNewsUpdates((prev) => {
      let updatedIds;

      if (checked) {
        // Add the id to the list if checked
        updatedIds = [...prev, id];
      } else {
        // Remove the id from the list if unchecked
        updatedIds = prev.filter((item) => item !== id);
      }

      // Remove duplicates
      updatedIds = Array.from(new Set(updatedIds));
      updateRole(updatedIds);
      // Log the updated unique ids

      return updatedIds; // Return the updated state
    });
  };

  const permissions =
    permi?.data.map((permission) => (
      <div className={s.input} key={permission.id}>
        <input
          type="checkbox"
          id={permission.id}
          checked={rolePermission?.permissions
            .map((item) => item.id)
            .includes(permission.id)}
          //checked={permission._id === rolePermission?.permissions.map(item=>item._id)} // Dynamically bind state
          onChange={handleNewsUpdatesChange}
        />
        <label htmlFor={permission.id}>{permission.name}</label>
      </div>
    )) || null;
  const updateRole = async (updatedPermissions: string[]) => {
    const jsonBody = { permissions: updatedPermissions };
    try {
      const fetchArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "PATCH",
          body: JSON.stringify(jsonBody),
          headers: {
            "Content-Type": "application/json",
          },
        },
      };
      const result: SuccessDataType<any> = await updateRolePermission(fetchArg);
      mutate();
      mutatePermission()
      generateResult("success",result.message.charAt(0).toUpperCase() + result.message.slice(1))
      
    } catch (error) {
      const e = parseClientError(error);
      generateResult("error",e.message||"Something went wrong")
    }
  };
  useEffect(() => {
    if (roles && filter) {
      const matchingRole = roles.data.find((role) => role.id === filter);
      setPermissions(matchingRole);
      if (matchingRole)
        setNewsUpdates([...matchingRole?.permissions.map((item) => item.id)]);
    } else if (roles && !filter) {
      setPermissions(roles.data[0]);
      setNewsUpdates([...roles.data[0].permissions.map((item) => item.id)]);
    }
  }, [filter, roles]);
  useEffect(() => {
    if (error) {
      const e = parseClientError(error);
      if (e.statusCode === 403) {
        setRoleUnauthorized(true);
      } else {
        setRoleUnauthorized({ message: e.message, title: "Error!" });
      }
    }
  }, [error]);
  return (
    <div className={s.wrapper}>
      <div className={s.head}>
        <h3 className={s.rolePermission}>Role permission</h3>
      </div>
      {isLoading ? (
        <div className={s.spin}>
          <ThreeDots
            visible={true}
            height="50"
            width="50"
            color="#d52b1e"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{
              dispaly: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
            wrapperClass=""
          />
        </div>
      ) : roleUnauthorized ? (
        typeof roleUnauthorized === "boolean" ? (
          <div className={s.spin}>
            <Unauthorised />
          </div>
        ) : (
          <div className={s.spin}>
            <Unauthorised error={roleUnauthorized} />
          </div>
        )
      ) : roles ? (
        <>
          <SelectField
            bordered
            defaultValue={roles && roles.data[0].id}
            label={"Role:"}
            wrapperClassname={s.SelectWrapper}
            onChange={(value: any) => handleFilter(value)}
            className={s.selectInput}
            style={{ width: "100%", height: "100%" }}
            options={roles?.data.map((role) => ({
              value: role.id,
              label: role.title,
            }))}
          />
          {permi ? (
            isMutating ? (
              <div className={s.spin}>
                <ThreeDots
                  visible={true}
                  height="50"
                  width="50"
                  color="#d52b1e"
                  radius="9"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{
                    dispaly: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                  }}
                  wrapperClass=""
                />
              </div>
            ) : (
              <div className={s.inputs}>{permissions}</div>
            )
          ) : (
            <Empty />
          )}
        </>
      ) : (
        <Empty />
      )}
    </div>
  );
}

export default RolePermission;
